import { Asset, Site, SiteArea } from 'graphql-common';
import FieldNames from '@lib/enums/fieldNames/interventionFieldNames';

export default function getInterventionDefaultValues({
  site,
  siteArea,
  asset,
}: {
  site?: Site | null;
  siteArea?: SiteArea | null;
  asset?: Asset | null;
}) {
  const shouldPrefillArea =
    (asset?.siteAreaId && siteArea?.id && asset.siteAreaId === siteArea.id) ||
    (siteArea?.id && asset?.siteAreaId === null);
  return {
    [FieldNames.Name]: '',
    [FieldNames.Description]: '',
    [FieldNames.AttachmentsAttached]: [],
    [FieldNames.Code]: '',
    [FieldNames.EstimatedTime]: null,
    [FieldNames.EstimatedDate]: null,
    [FieldNames.LogisticTime]: null,
    [FieldNames.DurationTime]: null,
    [FieldNames.Category]: null,
    [FieldNames.Priority]: null,
    [FieldNames.Status]: null,
    [FieldNames.Supervisor]: null,
    [FieldNames.Assignee]: [],
    [FieldNames.AssigneeList]: [],
    [FieldNames.Site]: site?.id ? { label: site.name, value: site.id } : null,
    [FieldNames.SiteArea]: shouldPrefillArea
      ? { label: siteArea?.name, value: siteArea?.id }
      : null,
    [FieldNames.Asset]: asset?.id
      ? { label: asset?.name, value: asset?.id, data: asset }
      : null,
    [FieldNames.Task]: null,
    [FieldNames.Completions]: [],
    // Custom renders
    [FieldNames.DetailsTitle]: null,
    [FieldNames.SubjectsTitle]: null,
    [FieldNames.AssignationTitle]: null,
    [FieldNames.TimingTitle]: null,
  };
}
